<template>
  <el-collapse-transition>
    <canvas
      v-show="state.rulerVisible"
      ref="canvas"
      :style="{
        transition: '.3s all',
        background: 'rgba(0,0,0,.7)',
        position: 'absolute',
        left: '0',
        top: '0'
      }"
    >您的浏览器不支持canvas 请使用最新版浏览器</canvas>
  </el-collapse-transition>
</template>

<script>
import store from '../../../store/index.js'

export default {
  name: 'TumengRuler',
  props: {
    // 尺子方向
    direction: {
      type: String,
      default: 'horizontal'
    }
  },
  data() {
    return {
      state: store.state,
      thickness: 30
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    // 打开之后初始化
    init() {
      if (!this.$refs.canvas) {
        return setTimeout(this.init, 1)
      }

      if (this.direction === 'horizontal') {
        this.$watch(function() {
          return store.state.designAreaWidth
        }, this.handleCursorPositionChange)
      } else {
        this.$watch(function() {
          return store.state.designAreaHeight
        }, this.handleCursorPositionChange)
      }

      this.$watch(function() {
        return store.state.cursorX + ':' + store.state.cursorY
      }, this.handleCursorPositionChange)

      // 这个方法绘制/重绘canvas
      this.handleCursorPositionChange()
    },
    // 需要重新绘制canvas
    handleCursorPositionChange() {
      this.$emit('get-canvas-position')

      const oc = this.$refs.canvas
      const ctx = oc.getContext('2d')

      if (this.direction === 'horizontal') {
        oc.height = this.thickness
        oc.width = store.state.designAreaWidth || 0
      } else {
        oc.width = this.thickness
        oc.height = store.state.designAreaHeight || 0
      }

      // 清除之前画的内容
      ctx.clearRect(0, 0, oc.clientWidth, oc.clientHeight)

      // 画鼠标位置的方块
      ctx.fillStyle = '#dd3213'
      if (this.direction === 'horizontal') {
        ctx.fillRect(store.state.cursorX - 220, 0, this.thickness, this.thickness)
      } else {
        ctx.fillRect(0, store.state.cursorY - 48, this.thickness, this.thickness)
      }

      let start
      if (this.direction === 'horizontal') {
        start = -1.0 * store.state.canvasAreaX + 220
      } else {
        start = -1.0 * store.state.canvasAreaY + 48
      }

      // 找到差了几个像素
      let singleDigit = start % 10
      if (singleDigit < 0) {
        singleDigit = Math.round(-1.0 * singleDigit)
      } else if (singleDigit > 0) {
        singleDigit = 10 - Math.round(singleDigit)
      }

      if (start < 0) {
        start = start - start % 10
      } else {
        start = start + 10 - start % 10
      }

      // 然后开始画刻度
      ctx.lineWidth = 1
      ctx.strokeStyle = '#FFF'
      ctx.font = '12px serif'
      ctx.textAlign = 'left'
      ctx.textBaseline = 'middle'
      ctx.fillStyle = 'rgba(204,204,204,.8)'
      if (this.direction === 'horizontal') {
        for (let i = 3; i < 200; i++) {
          ctx.beginPath()
          ctx.moveTo(10 * i + 0.5 + singleDigit, 0)
          ctx.lineTo(10 * i + 0.5 + singleDigit, (start + 10 * i) % 50 === 0 ? 12 : 5)
          ctx.stroke()
          if ((start + 10 * i) % 50 === 0) {
            ctx.fillText(start + 10 * i + '', 10 * i + 0.5 + singleDigit, 20)
          }
        }
      } else {
        for (let i = 3; i < 200; i++) {
          ctx.beginPath()
          ctx.moveTo(0, 10 * i + 0.5 + singleDigit)
          ctx.lineTo((start + 10 * i) % 50 === 0 ? 12 : 5, 10 * i + 0.5 + singleDigit)
          ctx.stroke()
          if ((start + 10 * i) % 50 === 0) {
            ctx.fillText(start + 10 * i + '', 5, 10 * i + 0.5 + singleDigit + 7)
          }
        }
      }
    }
  }
}
</script>
